import { render, staticRenderFns } from "./OrderListDeliveredPage.vue?vue&type=template&id=81f9a3da&scoped=true&"
import script from "./OrderListDeliveredPage.vue?vue&type=script&lang=js&"
export * from "./OrderListDeliveredPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f9a3da",
  null
  
)

export default component.exports